import { Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
} from '@angular/material/dialog';
import {
  MatCard,
  MatCardContent,
  MatCardFooter,
  MatCardHeader,
  MatCardSubtitle,
  MatCardTitle,
} from '@angular/material/card';
import { MatButton } from '@angular/material/button';
import { MatList, MatListItem } from '@angular/material/list';
import { MatIcon } from '@angular/material/icon';
import { MatLine } from '@angular/material/core';
import { MatDivider } from '@angular/material/divider';
import { NgForOf, NgIf } from '@angular/common';
import { last } from 'rxjs';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-modal-inconsistencia',
  templateUrl: './modal-inconsistencia.component.html',
  standalone: true,
  imports: [
    MatDialogActions,
    MatDialogClose,
    MatCardTitle,
    MatDialogContent,
    MatButton,
    MatCardSubtitle,
    MatCard,
    MatCardContent,
    MatList,
    MatListItem,
    MatIcon,
    MatLine,
    MatCardHeader,
    MatDivider,
    MatCardFooter,
    NgForOf,
    NgIf,
    RouterLink,
  ],
  styleUrl: './modal-inconsistencia.component.scss',
})
export class ModalInconsistenciaComponent {
  titulo: string = 'Atenção!';
  subtitulo: string = 'Verifique as inconsistências abaixo:';
  mensagens: string[] = ['Mensagem 1', 'Mensagem 2', 'Mensagem 3'];

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: { titulo?: string; subtitulo?: string; mensagens: string[] },
    public dialogRef: MatDialogRef<ModalInconsistenciaComponent>,
  ) {
    if (data.titulo) {
      this.titulo = data.titulo;
    }
    if (data.subtitulo) {
      this.subtitulo = data.subtitulo;
    }
    this.mensagens = data.mensagens;
  }

  protected readonly last = last;

  clicouSim(): void {
    this.dialogRef.close('sim');
  }
}
